export default __webpack_public_path__ + "static/media/gallery-wip-denix-scope-mount-hole_01.599837f5.jpg";